import React, { useState } from 'react';

const Faq = () => {
    const faqs = [
        {
            q: "Is Trustpoint's software HIPAA-compliant?",
            a: "Yes. All of Trustpoint's products, including the clinician dashboard, billing software, and reporting tools, are built with HIPAA compliance at the core. Patient data is stored securely, handled according to strict privacy protocols, and protected through encrypted workflows."
        },
        {
            q: "How does Trustpoint help private practices grow?",
            a: "We provide radical visibility into your RCM cycle and act as a proactive partner. By identifying zero-pay claims, reducing denial rates, and ensuring every dollar is tracked, we eliminate revenue 'black holes' allowing you to scale confidently."
        },
        {
            q: "What makes Trustpoint different from other healthcare platforms?",
            a: "Unlike traditional 'black-box' billing companies, we offer real-time claim tracking and concierge-style communication. You are never just a ticket number; you get a direct line to the specialist handling your accounts, paired with big-company capabilities."
        },
        {
            q: "Is it easy to switch to Trustpoint from another system?",
            a: "Absolutely. Our onboarding process is designed to be a seamless, three-step journey. We start with a Free Financial Audit of your current RCM setup, ensuring a completely risk-free transition with a clear, actionable plan."
        },
        {
            q: "What types of specialties does Trustpoint support?",
            a: "Trustpoint supports a wide array of medical specialties ranging from mental health to family practice and orthopedics. Our specialists are highly trained to adapt to the specific coding needs and payer shifts within your unique field."
        }
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? -1 : index);
        
        // Refresh AOS after the grid transition completes
        setTimeout(() => {
            if (window.AOS) {
                window.AOS.refresh();
            }
        }, 400);
    };

    return (
        <section id="faq" className="py-24 bg-gray-50">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16" data-aos="fade-up">
                    <h2 className="label-md mb-4 text-gray-500">FAQS</h2>
                    <h3 className="heading-lg">
                        Frequently asked questions
                    </h3>
                </div>

                <div className="border-t border-gray-200" data-aos="fade-up" data-aos-delay="200">
                    {faqs.map((faq, index) => {
                        const isActive = activeIndex === index;
                        return (
                            <div key={index} className={`faq-item border-b border-gray-200 transition-colors duration-300 ${isActive ? 'bg-white/50' : ''}`}>
                                <button 
                                    className="faq-button w-full px-4 sm:px-6 py-6 text-left flex justify-between items-center focus:outline-none group transition-all duration-300 cursor-pointer hover:bg-white/50" 
                                    onClick={() => toggleFaq(index)}
                                    aria-expanded={isActive}
                                >
                                    <span className="heading-md pr-4 mt-1">
                                        {faq.q}
                                    </span>
                                    <span className="relative w-4 h-4 text-accent flex-shrink-0">
                                        <span className="absolute top-1/2 left-0 w-full h-[1.5px] bg-current transform -translate-y-1/2 rounded-full"></span>
                                        <span className={`icon-v-line absolute top-0 left-1/2 w-[1.5px] h-full bg-current transform -translate-x-1/2 rounded-full transition-transform duration-300 ${isActive ? 'scale-y-0' : ''}`}></span>
                                    </span>
                                </button>
                                <div className={`faq-answer grid transition-all duration-300 overflow-hidden ${isActive ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                                    <div className="min-h-0">
                                        <div className="px-4 sm:px-6 pb-6 paragraph-md text-gray-600">
                                            {faq.a}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Faq;
